import QuickContactService from '@/services/QuickContactService.js'

export const state = {
}

export const mutations = {
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
    sendInquiryMail({ dispatch }, body) {
        return new Promise((resolve, reject) => {
            QuickContactService.sendInquiryMail(body)
            .then(response => {
                return resolve(response.data)
            })
            .catch(error => {
                const notification = {
                type: 'error',
                message: 'There was a problem sending quick contact mail: ' + error.message
                }
                dispatch('notification/add', notification, { root: true })
                return reject(error)
            })
        })
    }
}

export const getters = {}
